import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const refundRBAC = {
  pageID: 'ecc463229e3c64bf6dc560c6e29e1cff',
  elementID: {
    LihatDetail: '37c328d27e26896fb4adb5d212e1fbd2',
    ViewListOfRefund: 'd951c81d067cdcba397517ce1c076e31',
    BuatPengembalian: '354313f8b2a3692c9ab5912c52bd958e',
    TolakProsesPengembalian: '6999026eed3211ff95bd643724cdc105',
    SetujuiProsesPengembalian: 'c852c3a3bf539ea313f265aea102127c',
  },
} as const

export const useRBACRefundPage = createUseRBAC(refundRBAC.elementID)

export type UseRBACRefundPageType = ReturnType<typeof useRBACRefundPage>
